<template>
    <div class="container-fluid">
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].status }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_status"
                               value="active"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].status_active }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_status"
                               value="disable"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].status_disable }}
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].non_chinese_speaking }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_non_chinese_speaking_status"
                               value="ncs"
                               :disabled="loading"
                        ><span class="checkmark"></span>
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="" class="col-sm-3 col-form-label">{{ trans[locale].parent }}</label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_users"
                             id="parent_users"
                             :options="selector_user_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="is_multiple"
                             :close-on-select="false"
                             :hide-selected="true"
                             :searchable="true"
                             :internal-search="true"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :limit="limit" :limitText="limitText"
                             :loading="loading"
                             :disabled="loading"
                             :show-labels="false"
                             :show-no-results="false"
                             group-values="libs"
                             group-label="language"
                            :group-select="true"
                >
                </multiselect>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../../store/store';
    import UserSelector from './UserSelector';
    export default {
        mixins: [ UserSelector ],
        name: 'SelectorParent',
        components: { UserSelector },
        store,
        data() {
            return Object.assign(
                {
                    selector_selected_status: [ 'active' ],
                    selector_selected_non_chinese_speaking_status: [],
                    selector_user_type_options: [],
                }
            )
        },
        watch: {
            selector_selected_status: _.debounce(
                function(newVal) {
                    this.getUserOptions();
                },
                store.getters.debounceMS,
            ),

            selector_selected_non_chinese_speaking_status: _.debounce(
                function(newVal) {
                    this.getUserOptions();
                },
                store.getters.debounceMS,
            ),
        },
        methods: {
            initialSelector() {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [initialSelector]', 'gray');
                this.getUserOptions();
            },
            getUserOptions: _.debounce(function(){
                if (!_.isNull(self.selector_selected_year))
                {
                    let self = this;
                    let ignored_users = [];
                    let url = "/api/options/get-parent/_ALL_/";

                    let selected_users_ids = [];
                    _.forEach(self.selector_selected_users, (item) => {
                        selected_users_ids.push(item.key);
                    });
                    // url = url + _.join(selected_users_ids, this.array_delimiter);
                    let ignored_users_ids = [];
                    _.forEach(self.selector_ignored_users, (item) => {
                        ignored_users_ids.push(item.key);
                    });

                    let req_param = {
                        extra: 'with_group',
                        req_key: this.request_type,
                        ignored_users: ignored_users_ids,
                        selected_users: selected_users_ids,
                        extra_param: {
                            account_status: self.selector_selected_status
                        },
                        filter_state: 'standby'
                    };

                    if (_.size(self.selector_selected_non_chinese_speaking_status) > 0) {
                        req_param.extra_param.non_chinese_speaking_status = true;
                    }

                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getUserOptions] => ' + url, 'gray');
                    let method = 'post';

                    let successCallBack = (response) => {
                        self.selector_user_options = response.data;
                        if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getUserOptions]', 'success');
                        if (_.isUndefined(response.data[0].libs)) {
                            if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                        } else {
                            if (this.is_debug) this.debugMessage(' Total Options: ' + _.size(response.data[0].libs), 'success');
                        }
                    };
                    let failedCallBack = (error) => {
                        if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getUserOptions]', 'error');
                        if (this.is_debug) this.debugMessage(error, 'error');
                        if (error.response.status == '422') {
                            this.$store.commit('setValidationError', error.toString())
                        } else {
                            this.$store.commit('setError', error.toString())
                        }
                    };
                    this.postOptions(url, method, req_param, successCallBack, failedCallBack);
                }
            }, store.getters.debounceMS),
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UserPicker/SelectorParent.vue